import { Component, EventEmitter, Input, Output } from '@angular/core';

import { NgClass } from '@angular/common';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  standalone: true,
  imports: [NgClass],
})
export class ButtonComponent {
  @Input() classes: string | string[] = 'btn-primary btn-spinner-light';
  @Input() showSpinner = false;
  @Input() disabled = false;
  @Output() clicked = new EventEmitter();

  onClick() {
    this.clicked.emit();
  }
}
